import * as R from 'ramda'
import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { faFile } from '@fortawesome/free-regular-svg-icons'
import {
  Box,
  Button,
  Checkbox,
  CircularProgress,
  Divider,
  FormLabel,
  FormControlLabel,
  FormControl,
  FormGroup,
  Input,
  InputLabel,
  Link,
  ListItemText,
  MenuItem,
  Select,
  Step,
  StepButton,
  StepContent,
  Stepper,
  TextField,
  Typography,
} from '@material-ui/core'
import Autocomplete from '@material-ui/lab/Autocomplete'
import ChipInput from 'material-ui-chip-input'
import FsLightbox from 'fslightbox-react'

import { PictureAsPdf } from '@material-ui/icons'
import { DropzoneArea } from 'material-ui-dropzone'
import Swal from 'sweetalert2'

import {
  findIndex,
  mapIndexed,
  nilOrEmpty,
  notNilOrEmpty,
} from '../lib/Helpers'
import Testimonial from '../services/Testimonial'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const INITIAL_EXHIBITOR_STATE = {
  category: '',
  city: '',
  email: '',
  profile_img: null,
  profile_img_name: '',
  state: '',
  story: '',
  title: '',
  video: '',
}

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  button: {
    borderRadius: 0,
    marginTop: theme.spacing(1),
    marginRight: theme.spacing(1),
    backgroundColor: '#EC232F',
    color: 'white',
  },
  actionsContainer: {
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(2),
    display: 'flex',
    justifyContent: 'center',
  },
  resetContainer: {
    padding: theme.spacing(3),
  },
  divider: {
    margin: '0 1rem',
  },
  companyImage: {
    width: '100px',
    height: '100px',
    margin: 'auto',
    marginBottom: '1rem',
  },
  exhibitorImageContainer: {
    width: '100%',
    display: 'flex',
    alignitems: 'center',
    flexFlow: 'column',
  },
  filesContainer: {
    width: '100%',
    display: 'flex',
    alignitems: 'center',
    flexFlow: 'row',
    flexWrap: 'wrap',
  },
  fileContainer: {
    width: 'auto',
    display: 'flex',
    alignitems: 'center',
    flexFlow: 'column',
    padding: '0.5rem',
  },
  fileIcon: {
    margin: 'auto',
    marginBottom: '1rem',
  },
  loaderContainer: {
    display: 'flex',
    alignitems: 'center',
    flexFlow: 'column',
    width: '100%',
    height: '100%',
    position: 'absolute',
    background: 'rgba(255,255,255,0.7)',
    zIndex: 1000,
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
  },
  loader: {
    margin: 'auto',
  },
  cityState: {
    '& .MuiTextField-root': {
      margin: theme.spacing(1),
      width: 200,
    },
  },
}))

function getSteps() {
  return ['Personal Information', 'Quit Story', 'Photo or Video']
}

const getFormInitialState = (testimonial) => {
  return INITIAL_EXHIBITOR_STATE
}

export default function TestimonialForm({ client, testimonial, exhibitors }) {
  const classes = useStyles()
  const [isLoading, setIsLoadingState] = React.useState(false)
  const [acceptedTerms, setAcceptedTerms] = React.useState(false)
  const [showForm, setShowForm] = React.useState(true)
  const [cats, setCats] = React.useState([])
  const [formData, setFormData] = React.useState(
    getFormInitialState(testimonial)
  )
  const [activeStep, setActiveStep] = React.useState(0)
  const steps = getSteps()

  React.useEffect(() => {
    getClient()
    // const el =
    //   typeof document !== 'undefined' && document.getElementById('stepper-form')
    // typeof document !== 'undefined' &&
    //   window.scroll({ top: el.offsetTop - 150, behavior: 'smooth' })
  }, [])

  function getClient() {
    const cats = `*[_type == "category"]`

    client
      .fetch(cats)
      .then((vt) => {
        setCats(vt)
      })
      .catch((err) => console.error(err))
  }

  function _handleInputChange(e) {
    e.preventDefault()

    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    })
  }

  function _handleAddingImage(id, e) {
    const name = `${id}_name`
    notNilOrEmpty(e) &&
      setFormData({
        ...formData,
        [id]: e[0],
        [name]: e[0].name,
      })
  }

  async function _handleForm(e) {
    try {
      e.preventDefault()
      setIsLoadingState(true)
      // creating the object to send to sanity
      const nextTestimonial = new Testimonial(
        formData,
        client,
        getFormInitialState(testimonial)
      )
      const testimonialRecord = nextTestimonial.createTestimonial()

      setShowForm(false)
      setActiveStep(0)
      setIsLoadingState(false)
    } catch (error) {
      console.error('ERROR', error)
      setIsLoadingState(false)
      Swal.fire({
        title: 'Failed to save your information.',
        text: 'Please try again!',
        html: 'There was an error with your request',
        icon: 'error',
        showConfirmButton: true,
        confirmButtonText: 'Send Report',
        showCloseButton: false,
        heightAuto: false,
        padding: '3em',
        customClass: {
          popup: 'popup',
          confirmButton: 'btn btn--black btn-confirm',
        },
      })
    }
  }

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1)
    const el =
      typeof document !== 'undefined' && document.getElementById('stepper-form')
    typeof document !== 'undefined' &&
      window.scroll({ top: el.offsetTop - 150, behavior: 'smooth' })
  }

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1)
    const el =
      typeof document !== 'undefined' && document.getElementById('stepper-form')
    typeof document !== 'undefined' &&
      window.scroll({ top: el.offsetTop - 150, behavior: 'smooth' })
  }

  const _handleStepperBUtton = (n) => {
    setActiveStep(n)
  }

  return (
    <div className="container exhibitor-page page--new-exhibitor  page--testimonial-form">
      {isLoading && (
        <div className={classes.loaderContainer}>
          <CircularProgress className={classes.loader} />
        </div>
      )}
      <div
        className={`animated fadeIn section-content form-container-alignment`}
      >
        {showForm ? (
          <div className="form-container">
            <section className="intro-content">
              <h2>Submit Your Quit</h2>
              <p>
                Share your quit story with others and help inspire someone
                else’s quit journey. Tell us how you did it, who helped you, and
                how it feels to be tobacco free. We want to hear your story.
                Submit your quit today.
              </p>
            </section>
            <form onSubmit={_handleForm}>
              <Stepper
                id="stepper-form"
                activeStep={activeStep}
                orientation="vertical"
                classes={{
                  root: 'stepper-form',
                }}
              >
                <Step id="step-0" active>
                  <StepButton classes={{ root: 'step-button' }}>
                    <span style={{ color: 'white' }}>{steps[0]}</span>
                  </StepButton>
                  <StepContent>
                    <InputLabel
                      className="form-input input-label"
                      id="name-label"
                      required
                    >
                      Name
                    </InputLabel>
                    <FormControl variant="outlined" className="form-input">
                      <TextField
                        className="search-box-label"
                        variant="outlined"
                        color="secondary"
                        name="title"
                        onChange={_handleInputChange}
                        value={formData.title}
                        required
                        placeholder="Full Name"
                        error={
                          R.equals(testimonial, 'new')
                            ? R.gt(R.length(formData.title), 79)
                            : null
                        }
                        helperText={
                          R.equals(testimonial, 'new')
                            ? `(79 characters limit) / ${79 -
                                R.length(formData.title)} chars left}`
                            : ''
                        }
                      />
                    </FormControl>
                    <div className="two-columns">
                      <div>
                        <InputLabel
                          className="form-input input-label"
                          id="city-label"
                          required
                        >
                          City
                        </InputLabel>
                        <FormControl variant="outlined" className="form-input">
                          <TextField
                            className="search-box-label"
                            variant="outlined"
                            color="secondary"
                            name="city"
                            onChange={_handleInputChange}
                            value={formData.city}
                            required
                            placeholder="City"
                          />
                        </FormControl>
                      </div>
                      <div>
                        <InputLabel
                          className="form-input input-label"
                          id="state-label"
                          required
                        >
                          State
                        </InputLabel>
                        <FormControl variant="outlined" className="form-input">
                          <TextField
                            className="search-box-label"
                            variant="outlined"
                            color="secondary"
                            name="state"
                            onChange={_handleInputChange}
                            value={formData.state}
                            required
                            placeholder="State"
                          />
                        </FormControl>
                      </div>
                    </div>
                    <InputLabel
                      className="form-input input-label"
                      id="city-label"
                      required
                    >
                      Email
                    </InputLabel>
                    <FormControl variant="outlined" className="form-input">
                      <TextField
                        className="search-box-label"
                        variant="outlined"
                        color="secondary"
                        name="email"
                        onChange={_handleInputChange}
                        value={formData.email}
                        required
                        placeholder="name@email.com"
                      />
                    </FormControl>
                  </StepContent>
                </Step>
                <Step id="step-1" active>
                  <StepButton classes={{ root: 'step-button' }}>
                    <span style={{ color: 'white' }}>{steps[1]}</span>
                  </StepButton>
                  <StepContent>
                    <InputLabel
                      className="form-input input-label"
                      id="cat-label"
                      required
                    >
                      What did you quit?
                    </InputLabel>
                    <FormControl variant="filled" className="form-input">
                      <Select
                        labelId="cats-label"
                        className="select"
                        id="cats-select"
                        name="category"
                        onChange={_handleInputChange}
                        value={formData.category}
                        required
                        displayEmpty
                      >
                        <MenuItem value="" disabled>
                          Select a Product
                        </MenuItem>
                        {mapIndexed((cat, index) => {
                          return (
                            <MenuItem key={index} value={cat._id}>
                              <ListItemText primary={R.toUpper(cat.title)} />
                            </MenuItem>
                          )
                        })(R.compose(R.sort(R.ascend(R.prop('title'))))(cats))}
                      </Select>
                    </FormControl>
                    <InputLabel
                      className="form-input input-label"
                      id="city-label"
                    >
                      Your Story
                    </InputLabel>
                    <FormControl variant="outlined" className="form-input">
                      <TextField
                        className="textarea-input"
                        variant="outlined"
                        color="secondary"
                        name="story"
                        multiline
                        rows={6}
                        onChange={_handleInputChange}
                        value={formData.story}
                        placeholder="Type details, max 280 characters"
                      />
                    </FormControl>
                  </StepContent>
                </Step>
                <Step id="step-2" active>
                  <StepButton classes={{ root: 'step-button' }}>
                    <span style={{ color: 'white' }}>{steps[2]}</span>
                  </StepButton>
                  <StepContent>
                    <FormControl variant="outlined" className="form-input">
                      <DropzoneArea
                        required
                        acceptedFiles={['image/*']}
                        dropzoneText={
                          'Drag and drop your photo here or click to add'
                        }
                        filesLimit={1}
                        id="image-path"
                        name="profile_img"
                        onChange={(e) => _handleAddingImage('profile_img', e)}
                      />
                    </FormControl>
                    <InputLabel
                      className="form-input input-label"
                      id="video-label"
                    >
                      Add a YouTube Link
                    </InputLabel>
                    <FormControl variant="outlined" className="form-input">
                      <TextField
                        className="search-box-label"
                        variant="outlined"
                        color="secondary"
                        name="video"
                        onChange={_handleInputChange}
                        value={formData.video}
                        placeholder="https://www.youtube.com/watch?v=ItP45sPiuHU"
                      />
                    </FormControl>
                    <section className="footer-content">
                      <p>
                        By submitting this form, you consent to have your story
                        featured on WaytoQuit.org and be contacted about future
                        Share Your Quit opportunities.
                      </p>
                      <Checkbox
                        checked={acceptedTerms}
                        onChange={() => setAcceptedTerms(!acceptedTerms)}
                        name="terms"
                      />
                      I have read and agree to the{' '}
                      <a
                        href="https://waytoquit.com/privacy-policy/"
                        target="_blank"
                        style={{ color: 'white' }}
                      >
                        <u>terms and conditions</u>
                      </a>
                    </section>
                    <div className={classes.actionsContainer}>
                      <div>
                        <Button
                          variant="contained"
                          onClick={_handleForm}
                          className={classes.button}
                          disabled={R.not(
                            R.and(
                              !R.any(nilOrEmpty)([
                                formData.title,
                                formData.city,
                                formData.state,
                                formData.email,
                                formData.category,
                              ]),
                              acceptedTerms
                            )
                          )}
                        >
                          Submit
                        </Button>
                      </div>
                    </div>
                  </StepContent>
                </Step>
              </Stepper>
            </form>
          </div>
        ) : (
          <div>
            <h1>Thank you!</h1>
          </div>
        )}
      </div>
    </div>
  )
}
